module.exports = __webpack_public_path__ + "static/media/d3a.377a90a3.png";